import * as React from "react"

function IconSuspension(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      {...props}
    >
      <title>{"Suspension"}</title>
      <g fill="none" fillRule="evenodd">
        <path stroke="#E3E833" strokeWidth={2} d="M30 13v32" />
        <circle stroke="#E3E833" strokeWidth={2} cx={29.981} cy={10} r={3} />
        <circle stroke="#E3E833" strokeWidth={2} cx={29.981} cy={48} r={3} />
        <path
          stroke="#E3E833"
          strokeWidth={2}
          d="M21.981 32l16-6M21.981 40l16-6M21.981 24l16-6"
        />
      </g>
    </svg>
  )
}

export default IconSuspension
